/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ViewMasqBoxDetailsPageService";
const log: any = LoggerModule.getInstance();

export class ViewMasqBoxDetailsPageService {
  private static instance: ViewMasqBoxDetailsPageService;
  private vapp: VApplication;
  private boxDetails: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ViewMasqBoxDetailsPageService {
    if (!ViewMasqBoxDetailsPageService.instance) {
      ViewMasqBoxDetailsPageService.instance =
        new ViewMasqBoxDetailsPageService(props);
    }
    return ViewMasqBoxDetailsPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  private getTotalAmountInt = (data: any) => {
    let totalAmount: any = 0;
    data?.map((item: any) => {
      if (
        item?.costumeValue?.topupPrice &&
        is.existy(item?.costumeValue?.topupPrice)
      ) {
        if (typeof item?.costumeValue?.topupPrice === "string") {
          totalAmount += parseFloat(item?.costumeValue?.topupPrice);
        } else {
          totalAmount += item?.costumeValue?.topupPrice;
        }
      }
    });
    return totalAmount;
  };

  //TODO THIS IS TEMPORARY FIXES NEEDS TO GET FROM BACK END
  private getRemainingAmount = (data: any) => {
    let sum = 0;
    let totalAmount = this.getTotalAmountInt(data?.items);
    const payOrder = data?.payOrder;
    if (payOrder?.payTxes && Array.isArray(payOrder?.payTxes)) {
      for (const tx of payOrder?.payTxes) {
        if (tx.amount) {
          sum += tx.amount;
        }
      }
    }
    return totalAmount - sum;
  };

  public validateAmout(amount: any) {
    const rem = this.getRemainingAmount(this.getBoxDetails());
    if (parseInt(amount) > rem) {
      return `Enter amount ${amount} is more the remaining amount ${rem}`;
    }
    return null;
  }

  public getRemainingAmountVal() {
    const rem = this.getRemainingAmount(this.getBoxDetails());
    return rem;
  }

  public getBoxDetails() {
    return this.boxDetails;
  }
  private setBoxDetails(data: any) {
    this.boxDetails = data;
  }

  public async getBoxes(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getBoxes(arg);
    this.setBoxDetails(content?.data);
    return content;
  }

  public async suspendUser(args: any) {
    log.info(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }

  public async activateUser(args: any) {
    log.info(`activate  user service`, args);
    const agent = getAgent();
    return agent.getActivateUser(args);
  }

  public async createPayTx(arg: any) {
    let content: any = {};
    let payDetails: any;
    const agent = getAgent();
    payDetails = this.getBoxDetails();

    console.log("createPayTx--->", payDetails);
    content = await agent.createPayTx({ ...arg, ...payDetails });
    return content;
  }

  public async updateBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async updateDelegateName(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateDelegateName(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async transferBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.TransferBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async changeMode(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.ChangeMode(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async deleteBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.deleteBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async updateValidEmailID(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateValidEmailID(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getInvoicePdf(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content.invoiceLink = await agent.getInvoicePdf(payload);

    return content;
  }

  public async addBoxNote(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.addBoxNote(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async checkPaymentFromPG(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.checkPaymentFromPG(payload);

    return content;
  }

  public async deletePayTx(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.deletePayTx(payload);

    return content;
  }
}
